import { Calendar, Badge, Select, Skeleton, Card } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import { timeZoneOptions } from "../../services/util";
import "./style.css";

const { Option } = Select;

function Schedule() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [calendarData, setCalendarData] = useState([]);
    const [formData, setFormData] = useState({ staff_id, time_zone: "PST" });

    const {
        status: calendarStatus,
        data: calendarRes,
        refetch: getCalendar,
    } = useQuery(
        "schedule",
        async () => {
            return await HTTP("/teams/getCalenderDetail", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        getCalendar();
    }, []);

    useEffect(() => {
        getCalendar();
    }, [formData]);

    useEffect(() => {
        if (calendarStatus == "success") {
            calendarRes.data.map((e) => {
                const dateShifts = Object.values(e);
                dateShifts.map((shift) =>
                    shift.map((member) => {
                        if (member.time_zone !== "PST") {
                            const [from_hours, from_minutes] =
                                member.timings_from.split(":");
                            member.timings_from = moment()
                                .set({
                                    hours: from_hours,
                                    minutes: from_minutes,
                                })
                                .format("HH:mm");

                            const [to_hours, to_minutes] =
                                member.timings_to.split(":");
                            member.timings_to = moment()
                                .set({
                                    hours: to_hours,
                                    minutes: to_minutes,
                                })
                                .format("HH:mm");
                        }
                    }),
                );
            });
            setCalendarData(calendarRes.data);
        }
    }, [calendarStatus, calendarRes]);

    const getListData = (value) => {
        let listData = [];
        const event = calendarData.find((e, index) => {
            return (
                moment(Object.keys(e)[0]).date() == value.date() &&
                moment(Object.keys(e)[0]).month() == value.month()
            );
        });
        if (event) {
            [listData] = Object.values(event);
        }
        return listData;
    };

    const dateCellRender = (value) => {
        const listData = getListData(value);
        let boxShadow = "rgb(0 0 0 / 16%) 0px 1px 4px";
        if (
            value.date() == moment().date() &&
            value.month() == moment().month()
        ) {
            boxShadow = "#7c38a1 0px 1px 4px";
        }
        return (
            <Card
                style={{
                    height: "30vh",
                    width: "11vw",
                    margin: "10px",
                    overflowY: "auto",
                    boxShadow,
                }}
            >
                <span>{value.date()}</span>
                <br />
                {listData.map((item) => {
                    return (
                        <>
                            <Badge
                                key={item.member_id}
                                status={"warning"}
                                text={`${item.name}(${item.timings_from} - ${item.timings_to})`}
                            />
                        </>
                    );
                })}
            </Card>
        );
    };

    function handleTimeZoneChange(value) {
        setFormData({ ...formData, time_zone: value });
    }

    return (
        <div className="calendar-container">
            {calendarData.length > 0 ? (
                <Calendar
                    style={{ height: "100vh" }}
                    dateFullCellRender={dateCellRender}
                    mode="month"
                    /* validRange={[
                        moment().startOf("week"),
                        moment().endOf("week").add(1, "day"),
                    ]} */
                    headerRender={() => {
                        return (
                            <div className="add-element-buttons-container display-flex flex-space-between">
                                <h2>{`Member's Shift Schedule`}</h2>
                                <Select
                                    onChange={handleTimeZoneChange}
                                    defaultValue={"PST"}
                                >
                                    {timeZoneOptions.map((e) => (
                                        <Option key={e} value={e}>
                                            {e}
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                        );
                    }}
                />
            ) : (
                <Skeleton active title={false} paragraph={{ rows: 20 }} />
            )}
        </div>
    );
}

export default Schedule;
